export enum LOADER_SIZE {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
}

const loaderSizeMap: Record<LOADER_SIZE, number> = {
    small: 16,
    medium: 20,
    large: 24,
};

export const handleLoaderSize = (size?: number | LOADER_SIZE): number => {
    if (!size) {
        return loaderSizeMap[LOADER_SIZE.MEDIUM];
    }

    if (typeof size === 'number') {
        return size;
    }

    return loaderSizeMap[size];
};
